import { Injectable } from "@angular/core";
import { IPRFIClassification } from "../api-generated";
import BaseService from "./base.service";

@Injectable({
  providedIn: "root",
})
export default class LocalClassificationService extends BaseService<IPRFIClassification> {}
